import { Stack } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { NavigationBar } from 'shared/components/vxl/navigation/NavigationBar/NavigationBar';
import { navigateBack } from 'shared/helpers/backNavigation.helpers';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';
import {
  showZendeskArticle,
  showZendeskFAQ,
  ZendeskArticles,
} from 'shared/utils/zendesk/zendeskUtils';

const handleLoginIssuePress = () => {
  showZendeskArticle(ZendeskArticles?.LOGIN_ISSUE);
};

const handleContactUsPress = () => {
  showZendeskArticle(ZendeskArticles?.CONTACT_US);
};

const handleFaqPress = () => {
  showZendeskFAQ();
};

const HairLine = () => (
  <View style={styles.hairLine}>
    <HairLineDivider />
  </View>
);

const HelpScreen = () => {
  const insets = useSafeAreaInsets();
  const { t: translatedText } = useTranslation('auth', {
    keyPrefix: 'help',
  });

  return (
    <View style={[styles.container, { paddingBottom: insets.bottom }]}>
      <Stack.Screen
        options={{
          title: translatedText('help'),
          headerShown: true,
          headerBackVisible: true,
          header: () => (
            <NavigationBar
              title={translatedText('help')}
              primaryIcon={<Icon iconKey="BACK" iconSize="MD" />}
              primaryOnPress={navigateBack}
              transparent={false}
            />
          ),
        }}
      />
      <ListItem
        primaryCopy={translatedText('loginIssue')}
        secondaryCopy={translatedText('loginIssueDescription')}
        showsChevron
        onPress={handleLoginIssuePress}
        analyticsId="loginIssueClicked"
        customAttributes={{
          faq_name: 'login_issues',
        }}
        leadingAccessory={{
          id: 'loginIcon',
          name: VXLComponentId.ICON,
          props: {
            iconKey: 'LOG_IN',
          },
        }}
      />
      <HairLine />
      <ListItem
        primaryCopy={translatedText('frequentlyQuestion')}
        secondaryCopy={translatedText('frequentlyQuestionDescription')}
        showsChevron
        onPress={handleFaqPress}
        analyticsId="faqIssueClicked"
        customAttributes={{
          faq_name: 'login_faq',
        }}
        leadingAccessory={{
          id: 'questionMarkIcon',
          name: VXLComponentId.ICON,
          props: {
            iconKey: 'QUESTION_MARK',
          },
        }}
      />
      <HairLine />
      <ListItem
        primaryCopy={translatedText('contactUs')}
        secondaryCopy={translatedText('contactUsDescription')}
        showsChevron
        onPress={handleContactUsPress}
        analyticsId="contactUsClicked"
        customAttributes={{
          faq_name: 'contact_us',
        }}
        leadingAccessory={{
          id: 'supportIcon',
          name: VXLComponentId.ICON,
          props: {
            iconKey: 'SUPPORT',
          },
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    display: 'flex',
    flex: 1,
    flexGrow: 1,
    justifyContent: 'flex-start',
    minHeight: `100%`,
    minWidth: `100%`,
  },
  hairLine: {
    marginHorizontal: theme.spacing.m,
  },
});

export default HelpScreen;
